export default __webpack_public_path__ + "static/media/icon-add-note.77f1015a.svg";